<template>
  <div class="insurance-detail">
    <!-- 保障项目 -->
    <div class="content-detail-nav">
      <div class="content-title">
        <div class="content-title-text">{{insuranceData.insurance_name}}</div>
        <img class="content-title-img" :src="insuranceData.company_logo" alt="">
      </div>

      <div class="content-detail">
        <div class="content-detail-title">
          <img src="../../../assets/imgs/insurance/guarantee.png" /> 保障项目
        </div>
        <div class="content-project" v-if="insuranceData.protect_items">
          <div class="project-body" v-for="(project, index) in uiSwitch.isProjectExpend ? insuranceData.protect_items : insuranceData.protect_items.slice(0, 10)" :key="index">
            <div class="first-line">{{project.name}}</div>
            <div class="project-line">{{project.claim}}</div>
          </div>
        </div>
      </div>

      <div class="content-expend" v-if="insuranceData.protect_items && insuranceData.protect_items.length > 10" :class="{'icon-reverse': uiSwitch.isProjectExpend}"
        @click="toggleUiExpend('isProjectExpend')">{{uiSwitch.isProjectExpend? '收起' : '查看全部项目'}}</div>
    </div>


    <!-- 投保明细 -->
    <div class="content-detail-nav">
       <div class="content-detail">
          <div class="content-detail-title">
            <img src="../../../assets/imgs/insurance/money.png" /> 保费明细
          </div>
          <div class="content-project" v-if="insuranceData.fee_desc">
            <div class="project-body" v-for="(project, index) in insuranceData.fee_desc" :key="index">
              <div class="first-line">{{project.key}}</div>
              <div class="project-line">{{project.value}}</div>
            </div>
          </div>
       </div>
    </div>

    <!-- 投保须知 -->
    <div class="content-detail-nav"  v-if="insuranceData.tips">
      <div class="content-process">
        <div class="content-detail-title">
          <img src="../../../assets/imgs/insurance/tip.png" /> 投保须知
        </div>

        <div class="info-content">
          <div class="info-text" v-html="tips"></div>
        </div>
      </div>

      <!-- <div class="content-expend" :class="{'icon-reverse': uiSwitch.isInfoExpend}" v-if="insuranceData.tips && insuranceData.tips.length > 5"
        @click="toggleUiExpend('isInfoExpend')">{{uiSwitch.isInfoExpend? '收起': '查看全部'}}</div> -->
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      uiSwitch: { // ui的开关标记
        isInfoExpend: false,
        isProjectExpend: false,
      },
    };
  },
  props: {
    insuranceData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    // 过滤投保须知数组
    tips() {
      return this.insuranceData.tips.replace(/\\t/g, '').replace(/\\n/g, '');
    },
  },
  methods: {
    toggleUiExpend(switchBar) {
      this.uiSwitch[switchBar] = !this.uiSwitch[switchBar];
    },
  },
};
</script>

<style lang="less">
@import "../../../assets/less/variable";

.content-title {
  font-size: 28px;
  color: @text-dark;
  position: relative;
  min-height: 98px;
  background-color: #fbfbfb;
  margin-bottom: 0px;
  padding: 18px 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .content-title-text {
    font-size: 24px;
    line-height: 36px;
  }
  .content-title-img {
    position: relative;
    flex-shrink: 0;
    margin-left: 10px;
  }
}

.content-detail-nav {
  width: 920px;
  margin: 10px auto;
  background-color: #fff;
  padding-bottom: 50px;
  &:first-of-type {
    margin-top: 50px;
  }
  &:last-of-type {
    margin-bottom: 50px;
  }

  .content-detail-title {
    display: flex;
    align-items: center;
    padding: 35px 25px 20px;
    font-size: 18px;
    color: #333333;
    font-weight: bold;
    img {
      margin-right: 10px;
    }
  }

  .content-detail {
    .content-description {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      margin-bottom: 40px;
      span {
        font-size: 12px;
        color: @text-aaa;
        position: relative;
        padding-left: 20px;
        margin-right: 30px;
        margin-bottom: 10px;
        &::before {
          content: '';
          position: absolute;
          left: 0px;
          top: -2px;
          width: 13px;
          height: 16px;
          background: url(../../../assets/imgs/insurance/insurance-shield.png) no-repeat center center;
        }
      }
    }
    .content-project {
      border: 1px solid @border;
      font-size: 14px;
      margin: 0 auto;
      width: 801px;
      .project-body {
        display: flex;
        border-bottom: 1px solid #fff;
        &:last-of-type {
          border-bottom: #fbfbfb;
        }
        .first-line {
          width: 500px;
          background-color: @active;
          flex-shrink: 0;
          color: @text-dark;
          padding: 18px 10px;
          background-color: #fff;
        }
        .project-line {
          background-color: #eaf3ff;
          width: 100%;
          text-align: center;
          color: @text-dark;
          padding: 18px 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-left: 1px solid @border;
          color: @text-dark;
        }
      }
    }
  }

  .content-expend {
    position: relative;
    font-size: 14px;
    color: @blue;
    min-width: 30px;
    display: inline-block;
    padding-right: 25px;
    margin-top: 20px;
    margin-left: 60px;
    cursor: pointer;
    &::after {
      content: '';
      position: absolute;
      right: 5px;
      top: 0px;
      width: 16px;
      height: 16px;
      background: url(../../../assets/imgs/insurance/insurance-expend-all.png) no-repeat center center;
    }
    &.icon-reverse {
      &::after {
        transform: rotate(-180deg);
      }
    }
  }

  .content-process {
    .info-content {
      padding: 0 60px 40px;
      .info-text {
        font-size: 14px;
        color: @text-6f;
        margin-bottom: 20px;
        line-height: 1.5;
        p {
          margin-bottom: 10px;
          font-size: 14px;
          line-height: 24px;
          color: #6f6f6f;
        }
        span {
          strong {
            color: red;
            font-weight: normal;
          }
          a {
            color: @blue;
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/businessInsurance/insurancePage/contentDetail.vue